import BaseEnum from './BaseEnum';

class NoSpendClients extends BaseEnum {
  fieldsMap = {
    customer: 'Customer',
    branch: 'Branch',
    branch_name: 'Branch name',
    brand: 'Brand',
    email_address: 'Email address',
    status: 'Status',
    last_order: 'Last order',
    orders: 'Orders',
    avgorder: 'Average order',
    net_total: 'Net total',
    toolkit: 'Toolkit',
    email: 'Email',
    bespoke: 'Bespoke',
    instantprint: 'Instant print',
    photofixr: 'Photofixr',
    myravensworth: 'Myravensworth',
    delivery: 'Delivery',
  }
}

export default NoSpendClients.make();